<template>
<div>
<v-row>
    <v-col>
        <v-chip
            v-for="(interval, index) in intervals"
            class="ma-2"
            :close="!disabled"
            :disabled="disabled"
            v-on:click:close="removeInterval(index)"
            v-on:click="editInterval(index)"
            dense
            :key="index"
            >
            {{interval}}
        </v-chip>

    </v-col>
    <v-col class="flex-grow-0 align-self-center">

        <v-menu 
            bottom 
            offset-y  
        >

            <template v-slot:activator="{ on }">
                
                <v-icon 
                    v-on="on"
                    v-show="!disabled"
                >
                    mdi-dots-vertical
                </v-icon>
                
            </template>

            <v-list>
                <v-list-item
                v-for="(item, menu_item_index) in menu_items"
                :key="menu_item_index"
                v-on:click="onClickMenuItem(item)"
                :disabled="item.disabled"
                >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
            </v-list>

        </v-menu> 

    </v-col>

    <m-interval-dialog
        ref="edit-interval-dialog"
        title="Edit Available Interval"
        v-on:ok="onEditInterval"
    />

    <v-overlay
    
        opacity="0.3"
        :value="show_spinner"
        z-index="10"
    >
        <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
    ></v-progress-circular>
</v-overlay>

</v-row>

<m-edit-message-patterns-compact
    v-show="dnd_auto_response_message_patterns != null && dnd_auto_response_message_patterns.length > 0"
    label="Auto reply when not available"
    :value="dnd_auto_response_message_patterns"
    :default_value="['Auto Reply: I am currently unavailable.  I will be available to help you {available}.']"
    context="dnd-auto-response"
    ref="edit-custom-auto-reply"
    v-on:input="setCustomAutoReply($event)"
/>

</div>
</template>

<script>
export default {

    props: {
        
        value: {
            type: Array,
            default: function() { return []; }
        },

        dnd_auto_response_message_patterns : {
            type: Array,
            default: function() { return []; }
        },
        
        offer_weekday_copy: {
            type: Boolean,
            default: function() { return false; }
        },

        offer_weekend_copy: {
            type: Boolean,
            default: function() { return false; }
        },

        offer_copy_all_days: {
            type: Boolean,
            default: function() { return false; }
        },

        offer_delete: {
            type: Boolean,
            default: function() { return false; }
        },

        disabled: {
            type: Boolean,
            default: function() { return false; }
        },

        offer_custom_auto_reply: {
            type: Boolean,
            default: function() { return false; }
        },
        
    },

    data() {
        return {
            intervals: [],
            show_spinner: false,
            edit_index: null,
            menu_items: [],
        }
    },

    mounted () {
        this.intervals = this.value;

        let menu_items = [];

        menu_items.push({ 'text' : 'Add...', 'code' : 'add' });

        if ( this.offer_custom_auto_reply )
        {
            menu_items.push({ 'text' : 'Edit Date(s)...', 'code' : 'edit_dates' });
        }

        menu_items.push({ 'text' : 'Not available at any time', 'code' : 'no_time' });
        menu_items.push({ 'text' : 'Available all day', 'code' : 'all_day' });
        
        if ( this.offer_custom_auto_reply )
        {
            menu_items.push({ 'text' : 'Set custom auto reply...', 'code' : 'custom_auto_reply' });
        }

        if ( this.offer_weekday_copy )
        {
            menu_items.push({ 'text' : 'Copy to all week days', 'code' : 'copy_weekday' });
        }

        if ( this.offer_weekend_copy )
        {
            menu_items.push({ 'text' : 'Copy to all weekend days', 'code' : 'copy_weekend' });
        }

        if ( this.offer_delete )
        {
            menu_items.push({ 'text' : 'Delete', 'code' : 'delete' });
        }

        if ( this.offer_copy_all_days )
        {
            menu_items.push({ 'text' : 'Copy to all days', 'code' : 'copy_all' });
        }

        this.menu_items = menu_items;
    },

    methods: {
        removeInterval(index) {
            this.intervals.splice(index,1);
            this.onChange();
        },

        editInterval(index) {
            this.edit_index = index;
            this.$refs['edit-interval-dialog'].showDialog(this.intervals[index]);
        },

        onEditInterval(new_interval) {
            if ( this.edit_index < 0 )
            {
                this.intervals.push(new_interval);
            }
            else
            {
                this.intervals[this.edit_index] = new_interval;
            }
            this.onChange();
        },

        onClickMenuItem(item)
        {
            if ( item.code == 'add' )
            {
                this.edit_index = -1;
                this.$refs['edit-interval-dialog'].showDialog("All Day");
            }

            if ( item.code == 'all_day' )
            {
                this.intervals = ['All Day'];
                this.onChange();
            }

            if ( item.code == 'no_time' )
            {
                this.intervals = [];
                this.onChange();
            }

            if ( item.code == 'copy_weekend')
            {
                this.$emit('copy_weekend');
            }

            if ( item.code == 'copy_weekday')
            {
                this.$emit('copy_weekday');
            }

            if ( item.code == 'delete')
            {
                this.$emit('delete');
            }

            if ( item.code == 'copy_all' )
            {
                this.$emit('copy_all');
            }

            if ( item.code == 'custom_auto_reply' )
            {
                this.$refs['edit-custom-auto-reply'].showDialog();
            }

            if ( item.code == 'edit_dates' )
            {
                this.$emit('edit-dates');
            }
        },

        setCustomAutoReply(new_auto_reply)
        {
            this.$emit('input-dnd-auto-response',new_auto_reply);
        },

        onChange()
        {
            this.show_spinner = true;

            this.$rc.normalizeIntervals(
                this.intervals,

                (normalized_intervals) => {
                    this.show_spinner = false;
                    this.intervals = normalized_intervals;
                    this.$emit('input',this.intervals);
                },

                () => {
                    this.show_spinner = false;
                    alert('Unable to modify intervals');
                }
            )
        }
    },

    watch: {
        value(newValue, oldValue) 
        {
            this.intervals = newValue;    
        }
    },
}
</script>

<style lang="scss" scoped>

</style>